import { render, staticRenderFns } from "./ClientGroupsView.vue?vue&type=template&id=e852fa1a&"
import script from "./ClientGroupsView.vue?vue&type=script&lang=js&"
export * from "./ClientGroupsView.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupsView.vue?vue&type=style&index=0&id=e852fa1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports